<script>
	import { getContext } from 'svelte';
	import client from '../client.js';
	import Button from './Button.svelte';
	import Popup from './popup/Popup.svelte';

	let options = getContext('options');
	let opened = options.start_state ? true : false;

	function handleClick() {
		opened = true;
	}

	function handleClose() {
		opened = false;
	}

	function showAr(event) {
		switch (client.OS) {
			case 'ios':
				window.location.href = event.detail.usdz + '?' + (new Date).getTime();
				break;
			case 'android':
				window.location.href = androidUrl(event.detail);
				break;
		}
	}

	function androidUrl({ gltf, fallback, title }) {
		gltf = encodeURIComponent(gltf + '?' + (new Date).getTime());
		fallback = encodeURIComponent(fallback);
		title = encodeURIComponent(title);
		let url = `intent://arvr.google.com/scene-viewer/1.0?`+
			`file=${gltf}&` +
			`resizable=false&` +
			`title=${title}&` +
			`mode=ar_preferred#Intent;` +
			`scheme=https;` +
			`package=com.google.ar.core;` +
			`action=android.intent.action.VIEW;` +
			`S.browser_fallback_url=${fallback};end`;
		return url;
	}
</script>

<Button on:click={handleClick} />

{#if opened}
	<Popup on:close={handleClose} on:showAr={showAr} />
{/if}